import httpService from "./httpService";

export default {

  getListContact(keyword, pageable, deptIds) {
    return httpService.post("/usersView/contacts", { keyword: keyword, deptIds: deptIds }, { params: pageable });
  },

  getCountContact(keyword, deptIds) {
    let params = {
      keyword: keyword,
      deptIds
    };
    return httpService.post("/usersView/count/contacts", params, {});
  },

  updateProfile(id, form) {
    return httpService.put(`/usersView/v1/${id}`, form);
  },

  findById(id) {
    return httpService.get(`/usersView/contacts/${id}`);
  },

  getListCert(cardId) {
    let params = {
      cardId: cardId
    };
    return httpService.post(`/usersView/getCertificates`, params);
  }
}



// WEBPACK FOOTER //
// ./src/services/contactService.js